module.exports = __webpack_public_path__ + "img/abisai.78755545.webp";